module.exports = __webpack_public_path__ + "static/organize-estude-melhor-1682c3dc74dca374246f03b1abbd1020.jpg";